export const getCurrentPlatform = async () => {
  const { platform } = await import('@tauri-apps/plugin-os')
  const currentPlatform = platform()
  return currentPlatform
}

export const isLinuxOrUnixPlatform = async () => {
  const { platform } = await import('@tauri-apps/plugin-os')
  const currentPlatform = platform()
  return currentPlatform === 'linux' || currentPlatform === 'macos'
}
